import PARENT from '../types';

const RIGHT_PANE = `${PARENT}/RIGHT_PANE`;

export const SET_BIN_WIDTH = `${RIGHT_PANE}/SET_BIN_WIDTH`;
export const SET_MIN_BIN_WIDTH = `${RIGHT_PANE}/SET_MIN_BIN_WIDTH`;
export const SET_ACTIVE_CHARTS_AND_GRAPHS_TAB = `${RIGHT_PANE}/SET_ACTIVE_CHARTS_AND_GRAPHS_TAB`;

export const SET_STARTING_POINT = `${RIGHT_PANE}/SET_STARTING_POINT`;
export const SET_MIN_STARTING_POINT = `${RIGHT_PANE}/SET_MIN_STARTING_POINT`;

export default RIGHT_PANE;
